import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Map, List } from 'immutable'
import _ from 'lodash'

import config from '../../../../../../config'

import { openReportById } from '../../actions'

import { ReportRecord } from './reducer'
import { blocksMapToSortedArray } from './helpers'

const MODULE_KEY = config.modules.report.key

function mapStateToProps(state) {
    const activeModule = state.getIn(['ui', 'moduleMenu', 'active'])
    const activeTab = state
        .getIn(['ui', 'tabs', 'tabs'])
        .find((tab) => tab.get('active') === true && tab.get('type') === activeModule)
    const id = activeTab && activeTab.get('id', null)
    let data = state.getIn(['ui', 'modules', MODULE_KEY, 'workspace', id])
    if (_.isNil(data)) data = new ReportRecord()

    const activeReportType = state.getIn(['ui', 'modules', MODULE_KEY, 'ribbon', 'reports', 'active'], null)
    const blocks = state.getIn(
        ['authorization', 'accessRights', MODULE_KEY, 'custom', 'reports', activeReportType, 'blocks'],
        Map()
    )
    const sortedBlocks = blocksMapToSortedArray(blocks)

    const noBlockShown = !data.get('blocks', Map()).some((b) => b.get('active', false))

    const bannerRights = state.getIn(
        ['authorization', 'accessRights', MODULE_KEY, 'custom', 'reports', activeReportType, 'banner'],
        List()
    )

    const showReportIndicator = data.getIn(['blocks', 'indicators', 'data', 'showReport'], null)

    return {
        activeReportId: id,
        reportData: {
            entity: data.get('entity', null),
        },
        sortedBlocks,
        noBlockShown,
        banner: {
            line: bannerRights.includes('upsellInline'),
            carousel: bannerRights.includes('upsellCarousel'),
        },
        showReportIndicator,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ openReportById }, dispatch)
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return HocConnect
}
